import Backbone from 'backbone';

import SequenceAlignmentTabOptionsView from 'analyses/alignment/SequenceAlignmentTabOptionsView';
import AnnotationsTableTabState from 'analyses/AnnotationsTableTabState';
import {AnnotationsTableTabView} from 'analyses/AnnotationsTableView';
import DigestTabState from 'analyses/DigestTabState';
// @ts-expect-error
import * as DigestView from 'analyses/DigestView';
import EditPrimerTabState from 'analyses/EditPrimerTabState';
import * as EditPrimerView from 'analyses/EditPrimerView';
import Primer3TabState from 'analyses/Primer3TabState';
import * as Primer3View from 'analyses/Primer3View';
import * as PrimerWizardTab from 'analyses/primers/PrimerWizardTab';
import PrimerWizardTabState from 'analyses/primers/PrimerWizardTabState';
import SecondaryStructureTabState from 'analyses/SecondaryStructureTabState';
// @ts-expect-error
import * as SecondaryStructureView from 'analyses/SecondaryStructureView';
import TranslationTabState from 'analyses/TranslationTabState';
import {TranslationTabView} from 'analyses/TranslationView';
import VirtualDigestTabState from 'analyses/VirtualDigestTabState';
// @ts-expect-error
import * as VirtualDigestView from 'analyses/VirtualDigestView';
import AnalysisTabState from 'analysis-tool/backbone/AnalysisTabState';
import AnalysisTabView from 'analysis-tool/backbone/AnalysisTabView';
import AnalysisTemplateTabState from 'analysis-tool/templates/AnalysisTemplateTabState';
import AnalysisTemplateTabView from 'analysis-tool/templates/AnalysisTemplateTabView';
import AntibodyMapTabOptionsView from 'antibodies/antibody-map/AntibodyMapTabOptionsView';
import AntibodyMapTabState from 'antibodies/antibody-map/AntibodyMapTabState';
import AntibodyMapTabView from 'antibodies/antibody-map/AntibodyMapTabView';
import JellyfishTabState from 'app-core/archetype/workspace/JellyfishTabState';
import JellyfishTabView from 'app-core/archetype/workspace/JellyfishTabView';
import GibsonTabState from 'assembly/tabs/GibsonTabState';
import * as GibsonTabView from 'assembly/tabs/GibsonTabView';
import GoldenGateTabState from 'assembly/tabs/GoldenGateTabState';
import * as GoldenGateTabView from 'assembly/tabs/GoldenGateTabView';
import BenchlingAppTabState from 'benchling-apps/backbone/BenchlingAppTabState';
import BenchlingAppTabView from 'benchling-apps/backbone/BenchlingAppTabView';
import MoleculeChemicalStructureTabState from 'chemistry/molecules/tabs/MoleculeChemicalStructureTabState';
import MoleculeChemicalStructureTabView from 'chemistry/molecules/tabs/MoleculeChemicalStructureTabView';
import MoleculePhysicochemicalPropertiesTabState from 'chemistry/molecules/tabs/MoleculePhysicochemicalPropertiesTabState';
import MoleculePhysicochemicalPropertiesTabView from 'chemistry/molecules/tabs/MoleculePhysicochemicalPropertiesTabView';
import DatasetTabState from 'data-frames/workspace/DatasetTabState';
import DatasetTabView from 'data-frames/workspace/DatasetTabView';
import {
  ExternalFileOptionsView,
  ExternalFileTabState,
  ExternalFileTabView,
  // @ts-expect-error
} from 'external-files/ExternalFileTab';
import FileTabState from 'files/workspace/FileTabState';
import FileTabView from 'files/workspace/FileTabView';
import FormDefinitionTabState from 'forms/form-definition/FormDefinitionTabState';
import FormDefinitionTabView from 'forms/form-definition/FormDefinitionTabView';
import AnalyticsDashboardTabState from 'insights/analytics-dashboards/backbone/AnalyticsDashboardTabState';
import AnalyticsDashboardTabView from 'insights/analytics-dashboards/backbone/AnalyticsDashboardTabView';
import EmbeddedAnalyticsDashboardTabState from 'insights/embeddings/backbone/EmbeddedAnalyticsDashboardTabState';
import EmbeddedAnalyticsDashboardTabView from 'insights/embeddings/backbone/EmbeddedAnalyticsDashboardTabView';
import ConnectionDataTabState from 'instruments/connections/connection-editor/ConnectionDataTabState';
import ConnectionDataTabView from 'instruments/connections/connection-editor/ConnectionDataTabView';
import ConnectionDetailsTabState from 'instruments/connections/connection-editor/ConnectionDetailsTabState';
import ConnectionDetailsTabView from 'instruments/connections/connection-editor/ConnectionDetailsTabView';
import ConnectionRunsTabState from 'instruments/connections/connection-editor/ConnectionRunsTabState';
import ConnectionRunsTabView from 'instruments/connections/connection-editor/ConnectionRunsTabView';
import MetadataTabState from 'metadata/MetadataTabState';
import MetadataTabView from 'metadata/MetadataTabView';
import ComplexPolymerComponentsTabState from 'modbio/complex-polymers/tabs/ComplexPolymerComponentsTabState';
import ComplexPolymerComponentsTabView from 'modbio/complex-polymers/tabs/ComplexPolymerComponentsTabView';
import ComplexPolymerMapTabState from 'modbio/complex-polymers/tabs/ComplexPolymerMapTabState';
import ComplexPolymerMapTabView from 'modbio/complex-polymers/tabs/ComplexPolymerMapTabView';
import GenerativeModelsTabState from 'model-hub/generative-models/GenerativeModelsTabState';
import GenerativeModelsTabView from 'model-hub/generative-models/GenerativeModelsTabView';
import ProteinAlignmentTabOptionsView from 'molbio/aa-sequences/alignments/AaSequenceAlignmentTabOptionsView';
import AlphaFoldTabState from 'molbio/aa-sequences/alphafold/AlphaFoldTabState';
import AlphaFoldTabView from 'molbio/aa-sequences/alphafold/AlphaFoldTabView';
import {
  BiochemicalPropertiesTabView,
  ProteinBiochemicalPropertiesTabState,
  TranslationBiochemicalPropertiesTabState,
} from 'molbio/aa-sequences/BiochemicalPropertiesTab';
import * as ProteinComplexPreviewTab from 'molbio/aa-sequences/complex/AaSequenceComplexPreviewTab';
import * as ProteinComplexPropertiesTab from 'molbio/aa-sequences/complex/AaSequenceComplexPropertiesTab';
import BulkAssemblyConstructsTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyConstructsTabState';
import BulkAssemblyConstructsTabView from 'molbio/bulk-assembly/backbone/BulkAssemblyConstructsTabView';
import BulkAssemblyFragmentsTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyFragmentsTabState';
import BulkAssemblyFragmentsTabView from 'molbio/bulk-assembly/backbone/BulkAssemblyFragmentsTabView';
import BulkAssemblyOverviewTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyOverviewTabState';
import BulkAssemblyOverviewTabView from 'molbio/bulk-assembly/backbone/BulkAssemblyOverviewTabView';
import CodonOptimizationTabState from 'molbio/codon-optimization/CodonOptimizationTabState';
import CodonOptimizationTabView from 'molbio/codon-optimization/CodonOptimizationTabView';
import CRISPRAssemblyTabState from 'molbio/crispr/assembly/CRISPRAssemblyTabState';
import {CRISPRAssemblyOptionsView, CRISPRAssemblyTabView} from 'molbio/crispr/assembly/CRISPRAssemblyTabView';
import CRISPRAnalysisTabState from 'molbio/crispr/CRISPRAnalysisTabState';
import {CRISPRAnalysisOptionsView, CRISPRAnalysisTabView} from 'molbio/crispr/CRISPRAnalysisTabView';
import HRTemplateTabState from 'molbio/crispr/hr-template/HRTemplateTabState';
import * as HRTemplateTabView from 'molbio/crispr/hr-template/HRTemplateTabView';
import {FindPrimersOptionsView} from 'molbio/find-primers/FindPrimersOptionsView';
import {FindPrimersTabState} from 'molbio/find-primers/FindPrimersTabState';
import FindPrimersView from 'molbio/find-primers/ReactFindPrimersTabView';
import ProteinAlignmentTabView from 'molbio/maps/alignment/AaSequenceAlignmentTabView';
import SequenceAlignmentTabView from 'molbio/maps/alignment/SequenceAlignmentTabView';
import {CircularMapTabView} from 'molbio/maps/circular/Circular';
import * as ProteinMapView from 'molbio/maps/linear/AaSequenceMapView';
import {SequenceLinearMapTabView} from 'molbio/maps/linear/Linear';
import {MiniMapTabView} from 'molbio/maps/linear/MiniMap';
import {CircularMapTabOptionsView} from 'molbio/maps/options/CircularSequenceOptionsView';
import {LinearMapTabOptionsView} from 'molbio/maps/options/LinearSequenceOptionsView';
import {MiniMapTabOptionsView} from 'molbio/maps/options/MiniMapSequenceOptionsView';
import NucleotidesTabState from 'molbio/monomers/NucleotidesTabState';
import NucleotidesTabView from 'molbio/monomers/NucleotidesTabView';
import ProteinAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import ProteinMapTabState from 'molbio/tabstates/AaSequenceMapTabState';
import CircularMapTabState from 'molbio/tabstates/CircularMapTabState';
import MiniMapTabState from 'molbio/tabstates/MiniMapTabState';
import OligoLinearMapTabState from 'molbio/tabstates/OligoLinearMapTabState';
import RNASequenceLinearMapTabState from 'molbio/tabstates/RNASequenceLinearMapTabState';
import RNASequenceMiniMapTabState from 'molbio/tabstates/RNASequenceMiniMapTabState';
import SequenceAlignmentTabState from 'molbio/tabstates/SequenceAlignmentTabState';
import SequenceLinearMapTabState from 'molbio/tabstates/SequenceLinearMapTabState';
import AssemblyHistoryTabState from 'molbio/visual-history/assembly-history/AssemblyHistoryTabState';
import AssemblyHistoryTabView from 'molbio/visual-history/assembly-history/AssemblyHistoryTabView';
import VisualHistoryTabState from 'molbio/visual-history/VisualHistoryTabState';
import VisualHistoryTabView from 'molbio/visual-history/VisualHistoryTabView';
import {TabState} from 'Navigation';
import * as BlobLinkTab from 'notebook/data-tables/BlobLinkTab';
import NoteLinkedEmbeddingTab from 'notebook/embeddings/NoteLinkedEmbeddingTab';
import {
  EmptyEntryOptionsView,
  EmptyEntryTabState,
  EmptyEntryTabView,
} from 'notebook/entries/backbone/tabs/EmptyEntryTab';
import EntryProtocolTabState from 'notebook/entries/backbone/tabs/EntryProtocolTab';
import * as EntryProtocolView from 'notebook/entries/backbone/tabs/EntryProtocolView';
import {
  ExternalEntryProtocolOptionsView,
  ExternalEntryProtocolTabState,
  ExternalEntryProtocolTabView,
} from 'notebook/entries/backbone/tabs/ExternalEntryProtocol';
import {
  NewEntryProtocolOptionsView,
  NewEntryProtocolTabState,
  NewEntryProtocolTabView,
} from 'notebook/entries/backbone/tabs/NewEntryProtocolTab';
import * as NoteLinkedFileTab from 'notebook/notes/attachments/NoteLinkedFileTab';
import NoteTabState from 'notebook/notes/tabs/NoteTabState';
// @ts-expect-error
import NoteTabView from 'notebook/notes/tabs/NoteTabView';
import ProtocolTabState from 'notebook/protocols/backbone/tabs/ProtocolTabState';
import * as ProtocolView from 'notebook/protocols/backbone/tabs/ProtocolTabView';
import ReviewHistoryTabState from 'notebook/reviews/ReviewHistoryTabState';
import ReviewHistoryTabView from 'notebook/reviews/ReviewHistoryTabView';
import ReviewTabState from 'notebook/reviews/ReviewTabState';
import {ReviewOptionsView, ReviewTabView} from 'notebook/reviews/ReviewView';
import WorksheetTabState from 'notebook/worksheets/workspace/WorksheetTabState';
import WorksheetTabView from 'notebook/worksheets/workspace/WorksheetTabView';
import ProcedureTabState from 'procedures/ProcedureTabState';
import ProcedureTabView from 'procedures/ProcedureTabView';
import ProcessDetailsTabState from 'processes/process-details/ProcessDetailsTabState';
import ProcessDetailsTabView from 'processes/process-details/ProcessDetailsTabView';
import ProcessFlowchartTabState from 'processes/process-details/ProcessFlowchartTabState';
import ProcessFlowchartTabView from 'processes/process-details/ProcessFlowchartTabView';
import ProcessTaskDetailsOutputsTabState from 'processes/process-task-details/ProcessTaskDetailsOutputsTabState';
import ProcessTaskDetailsOutputsTabView from 'processes/process-task-details/ProcessTaskDetailsOutputsTabView';
import ProcessTaskDetailsTabState from 'processes/process-task-details/ProcessTaskDetailsTabState';
import ProcessTaskDetailsTabView from 'processes/process-task-details/ProcessTaskDetailsTabView';
import ProcessTaskFlowchartTabState from 'processes/process-task-details/ProcessTaskFlowchartTabState';
import ProcessTaskFlowchartTabView from 'processes/process-task-details/ProcessTaskFlowchartTabView';
import RequestV2DefinitionTabState from 'processes/requests_v2/request-v2-definition/RequestV2DefinitionTabState';
import RequestV2DefinitionTabView from 'processes/requests_v2/request-v2-definition/RequestV2DefinitionTabView';
import RequestV2SubmissionDocumentTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocumentTabState';
import RequestV2SubmissionDocumentTabView from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocumentTabView';
import RequestV2SubmissionProgressAndOutputsTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputsTabState';
import RequestV2SubmissionProgressAndOutputsTabView from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputsTabView';
import ChildEntityTabState from 'registry/child-entities/ChildEntityTabState';
import ChildEntityTabView from 'registry/child-entities/ChildEntityTabView';
import EntityMapTab from 'registry/entity-map/tab/EntityMapTab';
import RelevantItemsTabState from 'relevant-items/RelevantItemsTabState';
import RelevantItemsTabView from 'relevant-items/RelevantItemsTabView';
import RequestDetailsTabState from 'requests/request-view/RequestDetailsTabState';
import RequestDetailsTabView from 'requests/request-view/RequestDetailsTabView';
import RequestResponseTabState from 'requests/request-view/RequestResponseTabState';
import RequestResponseTabView from 'requests/request-view/RequestResponseTabView';
import EntityResultsTabState from 'results/linked-results/EntityResultsTabState';
import EntityResultsTabView from 'results/linked-results/EntityResultsTabView';
import LinkedResultsTabState from 'results/linked-results/LinkedResultsTabState';
import LinkedResultsTabView from 'results/linked-results/LinkedResultsTabView';
import StorableResultsTabState from 'results/linked-results/StorableResultsTabState';
import StorableResultsTabView from 'results/linked-results/StorableResultsTabView';
import ResultStatusTabState from 'results/validation/status-tab/ResultStatusTabState';
import {ResultStatusTabView} from 'results/validation/status-tab/ResultStatusTabView';
import RunDetailsTabState from 'runs/editor/RunDetailsTabState';
import RunDetailsTabView from 'runs/editor/RunDetailsTabView';
import RunResultsTabState from 'runs/editor/RunResultsTabState';
import RunResultsTabView from 'runs/editor/RunResultsTabView';
import ContainerTestOrdersTabState from 'sample-tests/ui/test-orders/ContainerTestOrdersTabState';
import ContainerTestOrdersTabView from 'sample-tests/ui/test-orders/ContainerTestOrdersTabView';
import EntityTestOrdersTabState from 'sample-tests/ui/test-orders/EntityTestOrdersTabState';
import EntityTestOrdersTabView from 'sample-tests/ui/test-orders/EntityTestOrdersTabView';
import ContainerTabState from 'samples/containers/ContainerTabState';
import ContainerTabView from 'samples/containers/ContainerTabView';
import BoxTabState from 'samples/grids/BoxTabState';
import GridContentsTabState from 'samples/grids/GridContentsTabState';
import GridContentsTabView from 'samples/grids/GridContentsTabView';
import GridMetadataTabState from 'samples/grids/GridMetadataTabState';
import GridMetadataTabView from 'samples/grids/GridMetadataTabView';
import GridTabView from 'samples/grids/GridTabView';
import PlateTabState from 'samples/grids/PlateTabState';
import LocationTabState from 'samples/locations/LocationTabState';
import LocationTabView from 'samples/locations/LocationTabView';
import StorageTabState from 'samples/StorageTabState';
import StorageTabView from 'samples/StorageTabView';
import StudyDesignTabState from 'studies/workspace/tabs/StudyDesignTabState';
import StudyDesignTabView from 'studies/workspace/tabs/StudyDesignTabView';
import StudyListingTabState from 'studies/workspace/tabs/StudyListingTabState';
import StudyListingTabView from 'studies/workspace/tabs/StudyListingTabView';
import StudyOverviewTabState from 'studies/workspace/tabs/StudyOverviewTabState';
import StudyOverviewTabView from 'studies/workspace/tabs/StudyOverviewTabView';
import VisualizationState from 'studies/workspace/tabs/VisualizationState';
import VisualizationView from 'studies/workspace/tabs/VisualizationView';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GenericBackboneViewClass, Optional} from 'util/Types';

const TABSTATE_TO_VIEW: Array<{
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  tabState: {new (options?: any, attributes?: any): TabState};
  tabView: GenericBackboneViewClass<TabState, Backbone.View<TabState>>;
  optionsView?: Optional<GenericBackboneViewClass<TabState, Backbone.View<TabState>>>;
  dataTestAttrs?: DataTestAttrs;
}> = [
  {
    tabState: SequenceAlignmentTabState,
    tabView: SequenceAlignmentTabView,
    optionsView: SequenceAlignmentTabOptionsView,
  },
  {
    tabState: AlphaFoldTabState,
    tabView: AlphaFoldTabView.tabView,
    optionsView: AlphaFoldTabView.optionsView,
    dataTestAttrs: {component: 'ProteinStructureTab', element: 'root'},
  },
  {
    tabState: AnalysisTabState,
    tabView: AnalysisTabView,
  },
  {
    tabState: AnalysisTemplateTabState,
    tabView: AnalysisTemplateTabView,
  },
  {
    tabState: AnalyticsDashboardTabState,
    tabView: AnalyticsDashboardTabView,
  },
  {
    tabState: AnnotationsTableTabState,
    tabView: AnnotationsTableTabView,
  },
  {
    tabState: AntibodyMapTabState,
    tabView: AntibodyMapTabView,
    optionsView: AntibodyMapTabOptionsView,
  },
  {
    tabState: AssemblyHistoryTabState,
    tabView: AssemblyHistoryTabView,
    dataTestAttrs: {component: 'AssemblyHistoryTab', element: 'root'},
  },
  {
    tabState: BenchlingAppTabState,
    tabView: BenchlingAppTabView,
  },
  {
    tabState: TranslationBiochemicalPropertiesTabState,
    tabView: BiochemicalPropertiesTabView,
  },
  {
    tabState: ProteinBiochemicalPropertiesTabState,
    tabView: BiochemicalPropertiesTabView,
  },
  {
    tabState: BlobLinkTab.tabState,
    tabView: BlobLinkTab.tabView,
    optionsView: BlobLinkTab.optionsView,
  },
  {
    tabState: BoxTabState,
    tabView: GridTabView,
  },
  {
    tabState: BulkAssemblyConstructsTabState,
    tabView: BulkAssemblyConstructsTabView,
  },
  {
    tabState: BulkAssemblyFragmentsTabState,
    tabView: BulkAssemblyFragmentsTabView,
  },
  {
    tabState: BulkAssemblyOverviewTabState,
    tabView: BulkAssemblyOverviewTabView,
  },
  {
    tabState: ChildEntityTabState,
    tabView: ChildEntityTabView,
  },
  {
    tabState: CircularMapTabState,
    tabView: CircularMapTabView,
    optionsView: CircularMapTabOptionsView,
  },
  {
    tabState: CodonOptimizationTabState,
    tabView: CodonOptimizationTabView,
  },
  {
    tabState: ComplexPolymerMapTabState,
    tabView: ComplexPolymerMapTabView,
  },
  {
    tabState: ComplexPolymerComponentsTabState,
    tabView: ComplexPolymerComponentsTabView,
  },
  {
    tabState: ConnectionDataTabState,
    tabView: ConnectionDataTabView,
  },
  {
    tabState: ConnectionDetailsTabState,
    tabView: ConnectionDetailsTabView,
  },
  {
    tabState: ConnectionRunsTabState,
    tabView: ConnectionRunsTabView,
  },
  {
    tabState: ContainerTabState,
    tabView: ContainerTabView,
  },
  {
    tabState: CRISPRAnalysisTabState,
    tabView: CRISPRAnalysisTabView,
    optionsView: CRISPRAnalysisOptionsView,
    dataTestAttrs: {component: 'DesignCRISPRTab', element: 'root'},
  },
  {
    tabState: CRISPRAssemblyTabState,
    tabView: CRISPRAssemblyTabView,
    optionsView: CRISPRAssemblyOptionsView,
  },
  {
    tabState: DatasetTabState,
    tabView: DatasetTabView,
  },
  {
    tabState: DigestTabState,
    tabView: DigestView.TabView,
    optionsView: DigestView.OptionsView,
  },
  {
    tabState: EditPrimerTabState,
    tabView: EditPrimerView.TabView,
    optionsView: EditPrimerView.OptionsView,
    dataTestAttrs: {component: 'EditPrimerTab', element: 'root'},
  },
  {
    tabState: EmbeddedAnalyticsDashboardTabState,
    tabView: EmbeddedAnalyticsDashboardTabView,
  },
  {
    tabState: EmptyEntryTabState,
    tabView: EmptyEntryTabView,
    optionsView: EmptyEntryOptionsView,
  },
  {
    tabState: EntityResultsTabState,
    tabView: EntityResultsTabView,
    dataTestAttrs: {component: 'EntityResultsTab', element: 'root'},
  },
  EntityMapTab,
  {
    tabState: EntryProtocolTabState,
    tabView: EntryProtocolView.TabView,
    optionsView: EntryProtocolView.OptionsView,
  },
  {
    tabState: ExternalEntryProtocolTabState,
    tabView: ExternalEntryProtocolTabView,
    optionsView: ExternalEntryProtocolOptionsView,
  },
  {
    tabState: ExternalFileTabState,
    tabView: ExternalFileTabView,
    optionsView: ExternalFileOptionsView,
  },
  {
    tabState: FileTabState,
    tabView: FileTabView,
  },
  {
    tabState: FindPrimersTabState,
    tabView: FindPrimersView,
    optionsView: FindPrimersOptionsView,
    dataTestAttrs: {component: 'FindPrimersTab', element: 'root'},
  },
  {
    tabState: FormDefinitionTabState,
    tabView: FormDefinitionTabView,
  },
  {
    tabState: GenerativeModelsTabState,
    tabView: GenerativeModelsTabView,
  },
  {
    tabState: GibsonTabState,
    tabView: GibsonTabView.TabView,
    optionsView: GibsonTabView.OptionsView,
    dataTestAttrs: {component: 'GibsonAssemblyTab', element: 'root'},
  },
  {
    tabState: GoldenGateTabState,
    tabView: GoldenGateTabView.TabView,
    optionsView: GoldenGateTabView.OptionsView,
  },
  {
    tabState: GridContentsTabState,
    tabView: GridContentsTabView,
  },
  {
    tabState: GridMetadataTabState,
    tabView: GridMetadataTabView,
  },
  {
    tabState: HRTemplateTabState,
    tabView: HRTemplateTabView.TabView,
    optionsView: HRTemplateTabView.OptionsView,
  },
  {
    tabState: JellyfishTabState,
    tabView: JellyfishTabView,
  },
  {
    tabState: LocationTabState,
    tabView: LocationTabView,
  },
  {
    tabState: MetadataTabState,
    tabView: MetadataTabView,
  },
  {
    tabState: MiniMapTabState,
    tabView: MiniMapTabView,
    optionsView: MiniMapTabOptionsView,
  },
  {
    tabState: MoleculeChemicalStructureTabState,
    tabView: MoleculeChemicalStructureTabView,
  },
  {
    tabState: MoleculePhysicochemicalPropertiesTabState,
    tabView: MoleculePhysicochemicalPropertiesTabView,
  },
  {
    tabState: NewEntryProtocolTabState,
    tabView: NewEntryProtocolTabView,
    optionsView: NewEntryProtocolOptionsView,
  },
  NoteLinkedEmbeddingTab,
  {
    tabState: NoteLinkedFileTab.tabState,
    tabView: NoteLinkedFileTab.tabView,
    optionsView: NoteLinkedFileTab.optionsView,
  },
  {
    tabState: NoteTabState,
    tabView: NoteTabView,
  },
  {
    tabState: NucleotidesTabState,
    tabView: NucleotidesTabView,
    dataTestAttrs: {component: 'NucleotidesTab', element: 'root'},
  },
  {
    tabState: OligoLinearMapTabState,
    tabView: SequenceLinearMapTabView,
    optionsView: LinearMapTabOptionsView,
  },
  {
    tabState: PlateTabState,
    tabView: GridTabView,
  },
  {
    tabState: Primer3TabState,
    tabView: Primer3View.TabView,
    optionsView: Primer3View.OptionsView,
    dataTestAttrs: {component: 'Primer3ResultsTab', element: 'root'},
  },
  {
    tabState: PrimerWizardTabState,
    tabView: PrimerWizardTab.TabView,
    optionsView: PrimerWizardTab.OptionsView,
    dataTestAttrs: {component: 'PrimerWizardTab', element: 'root'},
  },
  {
    tabState: ProcedureTabState,
    tabView: ProcedureTabView,
  },
  {
    tabState: ProcessDetailsTabState,
    tabView: ProcessDetailsTabView,
  },
  {
    tabState: ProcessFlowchartTabState,
    tabView: ProcessFlowchartTabView,
  },
  {
    tabState: ProcessTaskDetailsOutputsTabState,
    tabView: ProcessTaskDetailsOutputsTabView,
  },
  {
    tabState: ProcessTaskDetailsTabState,
    tabView: ProcessTaskDetailsTabView,
  },
  {
    tabState: ProcessTaskFlowchartTabState,
    tabView: ProcessTaskFlowchartTabView,
  },
  {
    tabState: ProteinAlignmentTabState,
    tabView: ProteinAlignmentTabView,
    optionsView: ProteinAlignmentTabOptionsView,
  },
  {
    tabState: ProteinComplexPreviewTab.tabState,
    tabView: ProteinComplexPreviewTab.tabView,
  },
  {
    tabState: ProteinComplexPropertiesTab.tabState,
    tabView: ProteinComplexPropertiesTab.tabView,
  },
  {
    tabState: ProteinMapTabState,
    tabView: ProteinMapView.TabView,
    optionsView: ProteinMapView.OptionsView,
  },
  {
    tabState: ProtocolTabState,
    tabView: ProtocolView.TabView,
    optionsView: ProtocolView.OptionsView,
  },
  {
    tabState: RelevantItemsTabState,
    tabView: RelevantItemsTabView,
  },
  {
    tabState: RequestDetailsTabState,
    tabView: RequestDetailsTabView,
  },
  {
    tabState: RequestResponseTabState,
    tabView: RequestResponseTabView,
  },
  {
    tabState: RequestV2DefinitionTabState,
    tabView: RequestV2DefinitionTabView,
  },
  {
    tabState: RequestV2SubmissionDocumentTabState,
    tabView: RequestV2SubmissionDocumentTabView,
  },
  {
    tabState: RequestV2SubmissionProgressAndOutputsTabState,
    tabView: RequestV2SubmissionProgressAndOutputsTabView,
  },
  {
    tabState: ResultStatusTabState,
    tabView: ResultStatusTabView,
  },
  {
    tabState: ReviewTabState,
    tabView: ReviewTabView,
    optionsView: ReviewOptionsView,
  },
  {
    tabState: ReviewHistoryTabState,
    tabView: ReviewHistoryTabView,
  },
  {
    tabState: RNASequenceLinearMapTabState,
    tabView: SequenceLinearMapTabView,
    optionsView: LinearMapTabOptionsView,
  },
  {
    tabState: RNASequenceMiniMapTabState,
    tabView: MiniMapTabView,
    optionsView: MiniMapTabOptionsView,
  },
  {
    tabState: RunDetailsTabState,
    tabView: RunDetailsTabView,
  },
  {
    tabState: RunResultsTabState,
    tabView: RunResultsTabView,
  },
  {
    tabState: SecondaryStructureTabState,
    tabView: SecondaryStructureView.TabView,
    optionsView: SecondaryStructureView.OptionsView,
  },
  {
    tabState: SequenceLinearMapTabState,
    tabView: SequenceLinearMapTabView,
    optionsView: LinearMapTabOptionsView,
  },
  {
    tabState: StorableResultsTabState,
    tabView: StorableResultsTabView,
  },
  {
    tabState: StorageTabState,
    tabView: StorageTabView,
  },
  {
    tabState: LinkedResultsTabState,
    tabView: LinkedResultsTabView,
  },
  {
    tabState: StudyListingTabState,
    tabView: StudyListingTabView,
  },
  {
    tabState: StudyDesignTabState,
    tabView: StudyDesignTabView,
  },
  {
    tabState: StudyOverviewTabState,
    tabView: StudyOverviewTabView,
  },
  {
    tabState: VisualizationState,
    tabView: VisualizationView,
  },
  {
    tabState: EntityTestOrdersTabState,
    tabView: EntityTestOrdersTabView,
  },
  {
    tabState: ContainerTestOrdersTabState,
    tabView: ContainerTestOrdersTabView,
  },
  {
    tabState: TranslationTabState,
    tabView: TranslationTabView,
  },
  {
    tabState: VirtualDigestTabState,
    tabView: VirtualDigestView.TabView,
    optionsView: VirtualDigestView.OptionsView,
  },
  {
    tabState: VisualHistoryTabState,
    tabView: VisualHistoryTabView,
  },
  {
    tabState: WorksheetTabState,
    tabView: WorksheetTabView,
  },
];

export type TabViewWithOptionalAfterAttachCallback = Backbone.View<TabState> & {afterAttach?(): void};

function getView(tabstate: TabState): {
  TabView: GenericBackboneViewClass<TabState, TabViewWithOptionalAfterAttachCallback>;
  OptionsView: Optional<GenericBackboneViewClass<TabState, Backbone.View<TabState>>>;
  dataTestAttrs?: DataTestAttrs;
} {
  for (const obj of TABSTATE_TO_VIEW) {
    if (tabstate instanceof obj.tabState) {
      return {TabView: obj.tabView, OptionsView: obj.optionsView, dataTestAttrs: obj.dataTestAttrs};
    }
  }
  throw new Error(`Unexpected tab state: ${tabstate.constructor.name}, please add it in buffers view`);
}

export {TABSTATE_TO_VIEW as __TABSTATE_TO_VIEW, getView};
